/* Handora PDP gallery, phones/tablets (<=1023px): native scroll-snap instead of Flickity.
   Loaded (defer) after vendor.js and before theme.js. It wraps theme.Flickity so the
   main product gallery and its thumbnail strip get a light controller instead of a
   Flickity instance; every other carousel, and desktop, still gets real Flickity.
   The controller keeps the parts of the Flickity API the theme and the Handora add-ons
   call (select, on, data, options, isActive, cells...). */
(function () {
  var F = window.theme && window.theme.Flickity;
  if (!F || F.__hoSnap) return;

  var MQ = window.matchMedia('(max-width: 1023px)');
  var SECTION = '[data-section-type="product-template"]';

  function el(x) { return typeof x === 'string' ? document.querySelector(x) : x; }
  function isTarget(e) {
    return !!(e && e.nodeType === 1 && MQ.matches && e.closest(SECTION) &&
      !e.classList.contains('flickity-enabled') &&
      (e.hasAttribute('data-product-single-media-slider') || e.hasAttribute('data-product-single-media-thumbs')));
  }

  function emitter(stub) {
    var h = {};
    stub.on = function (n, f) { (h[n] = h[n] || []).push(f); return stub; };
    stub.once = stub.on;
    stub.off = function (n, f) { if (h[n]) h[n] = h[n].filter(function (g) { return g !== f; }); return stub; };
    stub.emit = function (n, args) { (h[n] || []).slice().forEach(function (f) { try { f.apply(stub, args || []); } catch (e) { console.warn(e); } }); };
    stub.dispatchEvent = function (n, ev, args) { stub.emit(n, args); };
    return stub;
  }
  function noop() {}
  /* Flickity methods other scripts may call on the gallery; they have nothing to do here. */
  var NOOPS = ['updateDraggable', 'resize', 'reposition', 'destroy', 'reloadCells', 'activate', 'deactivate',
    'positionSliderAtSelected', 'setGallerySize', 'playPlayer', 'pausePlayer', 'stopPlayer', 'unpausePlayer',
    'insert', 'append', 'prepend', 'remove', 'watchCSS', 'uiChange', 'childUIPointerDown', 'updateSelectedSlide'];
  function addNoops(o) { NOOPS.forEach(function (k) { if (!o[k]) o[k] = noop; }); return o; }

  /* Thumbnail strip stub: the gallery controller drives it. */
  function thumbsStub(t) {
    var s = addNoops(emitter({ isActive: false, element: t, options: { draggable: false, wrapAround: false, contain: true }, cells: [] }));
    s.select = s.selectCell = noop;
    s.getCellElements = function () { return Array.prototype.slice.call(t.children); };
    s.viewport = s.slider = t; /* the theme adds a transitionend listener on .viewport */
    t.__hoStub = s;
    return s;
  }

  function galleryStub(slider) {
    var section = slider.closest(SECTION);
    var gallery = slider.parentNode;
    var slides = Array.prototype.filter.call(slider.children, function (c) { return c.hasAttribute('data-product-single-media-wrapper'); });
    var thumbsEl = section.querySelector('[data-product-single-media-thumbs]');
    var idx = 0, settleTimer = null, settled = 0;

    slider.__hosnap = true; /* the older Flickity-to-snap bridge leaves this slider alone */
    if (!slider.hasAttribute('tabindex')) slider.setAttribute('tabindex', '0');

    var s = emitter({
      isActive: true, element: slider, options: { draggable: false, adaptiveHeight: false, wrapAround: false, contain: true },
      cells: slides.map(function (e) { return { element: e }; }),
      selectedIndex: 0
    });
    Object.defineProperty(s, 'selectedElement', { get: function () { return slides[idx]; } });
    Object.defineProperty(s, 'selectedCell', { get: function () { return s.cells[idx]; } });
    addNoops(s);
    s.getCellElements = function () { return slides.slice(); };
    s.slides = s.cells;
    s.viewport = s.slider = slider;
    s.select = function (i, wrap, instant) { go(i, !instant); };
    s.selectCell = function (i, wrap, instant) { go(typeof i === 'number' ? i : slides.indexOf(el(i)), !instant); };
    s.previous = function () { go(idx - 1, true); };
    s.next = function () { go(idx + 1, true); };
    slider.__hoStub = s;

    function clamp(i) { return Math.max(0, Math.min(slides.length - 1, i | 0)); }

    function eager(i) {
      var c = slides[i];
      if (!c) return;
      c.querySelectorAll('img[loading="lazy"]').forEach(function (img) { img.loading = 'eager'; });
    }
    function eagerAround(i) { eager(i); eager(i + 1); eager(i + 2); eager(i - 1); }

    function thumbFor(i) {
      if (!thumbsEl || !slides[i]) return null;
      return thumbsEl.querySelector('[data-id="' + slides[i].getAttribute('data-id') + '"]');
    }
    function showThumb(t) {
      if (!t) return;
      var l = t.offsetLeft, r = l + t.offsetWidth, vl = thumbsEl.scrollLeft, vr = vl + thumbsEl.clientWidth;
      if (l < vl) thumbsEl.scrollTo({ left: l - 8, behavior: 'smooth' });
      else if (r > vr) thumbsEl.scrollTo({ left: r - thumbsEl.clientWidth + 8, behavior: 'smooth' });
    }

    function setActive(i, quiet) {
      i = clamp(i);
      if (i === idx && slides[i].classList.contains('is-selected')) return;
      idx = i;
      s.selectedIndex = i;
      slides.forEach(function (c, j) {
        c.classList.toggle('is-selected', j === i);
        c.setAttribute('aria-hidden', j === i ? 'false' : 'true');
      });
      if (thumbsEl) {
        var t = thumbFor(i);
        Array.prototype.forEach.call(thumbsEl.children, function (c) {
          var on = c === t;
          c.classList.toggle('is-nav-selected', on);
          c.classList.toggle('is-selected', on);
        });
        showThumb(t);
      }
      if (!quiet) eagerAround(i);
      s.emit('select', [i]);
      s.emit('change', [i]);
    }

    /* Same job as the theme's switchMedia(): pause media that left, show the one that arrived
       (a product video starts when the shopper swipes onto it, exactly as before). */
    function settle() {
      if (settled === idx + 1) return;
      settled = idx + 1;
      var cur = slides[idx];
      slides.forEach(function (c) {
        if (c === cur) return;
        if (!c.classList.contains('media--hidden')) c.dispatchEvent(new CustomEvent('theme:media:hidden', { bubbles: true }));
        c.classList.add('media--hidden');
      });
      cur.classList.remove('media--hidden');
      slider.classList.remove('has-media-active');
      cur.dispatchEvent(new CustomEvent('theme:media:visible', { bubbles: true }));
      var dm = cur.querySelector('[data-deferred-media]');
      if (dm && dm.getAttribute('loaded') !== 'true') {
        var b = cur.querySelector('[data-deferred-media-button]');
        if (b) b.dispatchEvent(new Event('click'));
      }
      s.emit('settle', [idx]);
    }

    function indexFromScroll() {
      var w = slider.clientWidth;
      return w ? clamp(Math.round(slider.scrollLeft / w)) : idx;
    }

    function go(i, smooth) {
      i = clamp(i);
      var x = slides[i].offsetLeft;
      eagerAround(i);
      if (Math.abs(slider.scrollLeft - x) < 2) { setActive(i); settle(); return; }
      if (smooth && slider.scrollTo) slider.scrollTo({ left: x, behavior: 'smooth' });
      else slider.scrollLeft = x;
      setActive(i);
      if (!smooth) settle();
    }

    var ticking = false;
    slider.addEventListener('scroll', function () {
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(function () { ticking = false; setActive(indexFromScroll()); });
      }
      clearTimeout(settleTimer);
      settleTimer = setTimeout(function () { setActive(indexFromScroll()); settle(); }, 140);
    }, { passive: true });
    if ('onscrollend' in window) {
      slider.addEventListener('scrollend', function () { clearTimeout(settleTimer); setActive(indexFromScroll()); settle(); }, { passive: true });
    }

    /* Finger on the photos: the next two are needed now, not later. */
    slider.addEventListener('touchstart', function () { eagerAround(idx); }, { passive: true });

    slider.addEventListener('keydown', function (e) {
      if (e.target !== slider) return;
      if (e.key === 'ArrowRight') { e.preventDefault(); go(idx + 1, true); }
      else if (e.key === 'ArrowLeft') { e.preventDefault(); go(idx - 1, true); }
    });

    if (thumbsEl) {
      thumbsEl.addEventListener('click', function (e) {
        var t = e.target.closest('.product-single__thumbnail');
        if (!t || !thumbsEl.contains(t)) return;
        e.preventDefault();
        var id = t.getAttribute('data-id');
        for (var j = 0; j < slides.length; j++) {
          if (slides[j].getAttribute('data-id') === id) { go(j, true); break; }
        }
      });
    }

    /* The favourite heart is appended to the slider by another script; move it onto the
       gallery so it does not scroll away with the photos. */
    function placeHeart(h) {
      if (h.parentNode !== gallery) gallery.appendChild(h);
      if (getComputedStyle(gallery).position === 'static') gallery.style.position = 'relative';
      var right = gallery.clientWidth - (slider.offsetLeft + slider.offsetWidth) + 14;
      h.style.setProperty('top', (slider.offsetTop + 14) + 'px', 'important');
      h.style.setProperty('right', right + 'px', 'important');
    }
    function findHeart() {
      var h = slider.querySelector(':scope > .hog-fav') || gallery.querySelector(':scope > .hog-fav');
      if (h) placeHeart(h);
    }
    new MutationObserver(findHeart).observe(slider, { childList: true });
    /* Only re-align when the gallery width really changed (rotation), not when the iOS
       address bar shows or hides during a scroll. */
    var lastW = slider.clientWidth;
    window.addEventListener('resize', function () {
      findHeart();
      var w = slider.clientWidth;
      if (w === lastW) return;
      lastW = w;
      if (MQ.matches && !slider.classList.contains('flickity-enabled')) slider.scrollLeft = slides[idx].offsetLeft;
    });

    /* Initial state, then warm the second photo once the page has finished loading. */
    var start = clamp(indexFromScroll());
    idx = -1;
    setActive(start, true);
    settled = start + 1; /* first slide is already shown, nothing to switch */
    function warm() { eager(start + 1); eager(start + 2); }
    if (document.readyState === 'complete') setTimeout(warm, 1200);
    else window.addEventListener('load', function () { setTimeout(warm, 1200); });

    return s;
  }

  function Wrapped(target, opts) {
    var e = el(target);
    if (isTarget(e)) {
      if (e.__hoStub) return e.__hoStub;
      return e.hasAttribute('data-product-single-media-slider') ? galleryStub(e) : thumbsStub(e);
    }
    return new F(target, opts);
  }
  Object.setPrototypeOf(Wrapped, F);
  Wrapped.prototype = F.prototype;
  Wrapped.data = function (target) {
    var e = el(target);
    var real = F.data(target);
    return real || (e && e.__hoStub) || undefined;
  };
  Wrapped.__hoSnap = true;
  window.theme.Flickity = Wrapped;
})();

/* Animated photos (webp/gif "motion" clips, marked data-ho-anim by snippets/media.liquid).
   The page shows a still first frame. The animation (0.9-1.6 MB) is fetched in the
   background once the page has loaded, or earlier if the shopper touches the photos,
   so it is usually ready by the time that photo is on screen. It plays only while that
   photo is the one on screen and returns to the still frame when the shopper moves on,
   so it never decodes in the background. The download is kept alive by its own Image
   object, so swiping away before it finishes does not cancel it. */
(function () {
  if (window.__hoAnim) return;
  window.__hoAnim = true;
  var SECTION = '[data-section-type="product-template"]';
  var cache = {};
  /* Phones get the 360px clip (~0.9 MB) instead of 540px (~1.6 MB): the photo is ~370px
     wide there and the motion reads the same, it just arrives about twice as fast. */
  var SMALL = window.matchMedia('(max-width: 1023px)').matches;
  function animUrl(im) {
    var u = im.getAttribute('data-ho-anim') || '';
    return SMALL ? u.replace(/([?&]width=)\d+/, '$1360') : u;
  }

  function animImg(slide) {
    return slide && slide.querySelector ? slide.querySelector('img[data-ho-anim]') : null;
  }
  function fetchAnim(url, done) {
    var c = cache[url];
    if (!c) {
      c = cache[url] = { img: new Image(), ready: false, cbs: [] };
      c.img.decoding = 'async';
      c.img.onload = function () {
        c.ready = true;
        var cbs = c.cbs; c.cbs = [];
        cbs.forEach(function (f) { f(); });
      };
      c.img.src = url;
    }
    if (done) { if (c.ready) done(); else c.cbs.push(done); }
    return c;
  }
  function prefetchAll() {
    document.querySelectorAll(SECTION + ' img[data-ho-anim]').forEach(function (im) {
      fetchAnim(animUrl(im));
    });
  }
  /* Show the clip by putting the already-downloaded Image in place of the still <img>
     (no second request, starts moving at once); put the still back when leaving. */
  function play(slide) {
    if (!slide || slide.__hoAnimOn) return;
    var still = slide.__hoStillImg || animImg(slide);
    if (!still) return;
    slide.__hoStillImg = still;
    slide.__hoAnimOn = true;
    var url = animUrl(still);
    var c = fetchAnim(url);
    fetchAnim(url, function () {
      if (!slide.__hoAnimOn || !still.parentNode) return;
      var live = c.img;
      live.className = still.className;
      live.alt = still.alt;
      ['width', 'height', 'style'].forEach(function (k) {
        var v = still.getAttribute(k);
        if (v != null) live.setAttribute(k, v);
      });
      live.setAttribute('data-ho-anim-live', '');
      still.replaceWith(live);
    });
  }
  function stop(slide) {
    if (!slide || !slide.__hoAnimOn) return;
    slide.__hoAnimOn = false;
    var still = slide.__hoStillImg;
    var live = slide.querySelector('img[data-ho-anim-live]');
    if (still && live && !still.parentNode) live.replaceWith(still);
  }
  document.addEventListener('theme:media:visible', function (e) { play(e.target); }, true);
  document.addEventListener('theme:media:hidden', function (e) { stop(e.target); }, true);

  /* Start the download the moment the shopper shows interest in the photos. */
  function onIntent(e) {
    var t = e.target;
    if (t && t.closest && t.closest(SECTION + ' [data-product-single-media-group], ' + SECTION + ' [data-product-single-media-thumbs]')) prefetchAll();
  }
  ['pointerdown', 'touchstart', 'mouseover'].forEach(function (n) {
    document.addEventListener(n, onIntent, { capture: true, passive: true });
  });
  /* Phone scroller: start the clip as soon as its photo is the one mostly on screen,
     without waiting for the swipe to fully settle (that can lag on a busy phone). */
  var rafPending = false;
  document.addEventListener('scroll', function (e) {
    var t = e.target;
    if (!(t && t.nodeType === 1 && t.hasAttribute('data-product-single-media-slider'))) return;
    prefetchAll();
    if (rafPending) return;
    rafPending = true;
    requestAnimationFrame(function () {
      rafPending = false;
      var w = t.clientWidth;
      if (!w) return;
      var slides = Array.prototype.filter.call(t.children, function (c) { return c.hasAttribute('data-product-single-media-wrapper'); });
      var i = Math.round(t.scrollLeft / w);
      slides.forEach(function (sl, j) { if (j === i) play(sl); else if (sl.__hoAnimOn) stop(sl); });
    });
  }, { capture: true, passive: true });

  function afterLoad() {
    /* A clip already on screen when the page opens starts now. */
    var shown = document.querySelector(SECTION + ' [data-product-single-media-wrapper].is-selected') ||
      document.querySelector(SECTION + ' [data-product-single-media-wrapper]:not(.media--hidden)');
    if (shown) play(shown);
    /* Once the page itself has loaded, get the clips ready in the background so the
       motion starts as soon as the shopper swipes to it (skipped on Data Saver / 2G). */
    var c = navigator.connection;
    var skip = c && (c.saveData || /(^|-)2g$/.test(c.effectiveType || ''));
    if (!skip && document.querySelector(SECTION + ' img[data-ho-anim]')) prefetchAll();
  }
  if (document.readyState === 'complete') setTimeout(afterLoad, 800);
  else window.addEventListener('load', function () { setTimeout(afterLoad, 800); });
})();

/* Deferred app blocks (sections/apps.liquid wraps the Judge.me review widget and reviews
   grid on product pages in <div data-ho-lazy-app><template>…</template></div>).
   Nothing of them is laid out, run or downloaded while the page loads. A few seconds after
   the page has loaded (or earlier, when the shopper scrolls to within about one screen of
   them or taps the star rating / a review link), the blocks go on the page, their inline data runs, and Judge.me's widget code is fetched the
   same way its loader does it on a normal page load. The holder keeps the space the
   reviews will take, so nothing below jumps when they appear. */
(function () {
  if (window.__hoLazyApp) return;
  window.__hoLazyApp = true;

  function hosts() { return Array.prototype.slice.call(document.querySelectorAll('[data-ho-lazy-app]')); }

  /* Same steps as Judge.me's loader.js for widgets present at page load. */
  var loadedEntry = {};
  function manifestCss(base, key) {
    return fetch(base + 'manifest.json?v=' + Date.now()).then(function (r) { return r.json(); }).then(function (m) {
      var seen = {};
      function add(href) {
        var u = base + href;
        if (document.querySelector('link[href="' + u + '"]')) return;
        var l = document.createElement('link'); l.rel = 'stylesheet'; l.href = u; document.head.appendChild(l);
      }
      function walk(k) {
        if (seen[k]) return; seen[k] = true;
        var c = m[k]; if (!c) return;
        (c.css || []).forEach(add); (c.imports || []).forEach(walk);
      }
      var top = m[key]; if (!top) return;
      (top.css || []).forEach(add); (top.imports || []).forEach(walk);
    }).catch(function () {});
  }
  function startWidget(e) {
    var J = window.jdgm || {}, S = window.jdgmSettings || {};
    var base = J.CDN_BASE_URL, ep = e.dataset.entryPoint, key = e.dataset.entryKey;
    if (!base || !ep || !key) return;
    if (e.dataset.widget === 'review') {
      var legacy = e.querySelector('.jdgm-legacy-widget-content');
      var hasLegacy = !!(legacy && legacy.innerHTML.trim().length > 20);
      var d = J.data && J.data.reviewWidget && J.data.reviewWidget[e.dataset.productId];
      var hasRevamp = !!(d && d.reviews !== void 0);
      var revamp = S.review_widget_revamp_enabled ? (hasRevamp || !hasLegacy) : (!hasLegacy && hasRevamp);
      if (!revamp) {
        if (legacy) legacy.style.display = '';
        var s0 = e.querySelector('.jdgm-ssr-reviews'); if (s0) s0.remove();
        return;
      }
    }
    var src = base + ep;
    var old = e.querySelector('.jdgm-rev-widg'); if (old) old.style.display = 'none';
    var ssr = e.querySelector('.jdgm-ssr-reviews'); if (ssr) ssr.remove();
    if (loadedEntry[src] || document.querySelector('script[src="' + src + '"]')) return;
    loadedEntry[src] = true;
    manifestCss(base, key).then(function () {
      var sc = document.createElement('script'); sc.type = 'module'; sc.src = src; document.head.appendChild(sc);
    });
  }

  /* Space kept for each block before it is drawn: the height it had last time on a screen
     of this width (remembered per visitor), else the stylesheet default. */
  var KEY = 'ho-lazy-h';
  function bucket() { return Math.round(window.innerWidth / 20) * 20; }
  function remembered() { try { return JSON.parse(localStorage.getItem(KEY) || '{}'); } catch (e) { return {}; } }
  function remember(kind, h) {
    try { var m = remembered(); m[kind + '@' + bucket()] = h; localStorage.setItem(KEY, JSON.stringify(m)); } catch (e) {}
  }
  function contentHeight(host) {
    var h = 0;
    Array.prototype.forEach.call(host.children, function (c) { if (c.tagName !== 'TEMPLATE') h += c.offsetHeight; });
    return h;
  }

  /* Once the reviews have drawn and stopped changing size, the holder takes their real
     height. If the holder is above the screen (the shopper already scrolled past), the
     page is scrolled by the same amount in the same frame, so nothing on screen moves. */
  function release(host) {
    var last = -1, still = 0, start = Date.now();
    var timer = setInterval(function () {
      if (Date.now() - start > 120000) { clearInterval(timer); return; }
      if (!host.classList.contains('is-ready')) return;
      var content = contentHeight(host);
      still = (content === last && content > 0) ? still + 1 : 0; last = content;
      if (still < 2) return;
      clearInterval(timer);
      remember(host.getAttribute('data-ho-lazy-app'), content);
      var above = host.getBoundingClientRect().bottom <= 0;
      var ref = host.closest('.shopify-section') || host;
      var y0 = ref.getBoundingClientRect().bottom;
      host.style.minHeight = '';
      host.classList.add('is-live');
      if (above) {
        var moved = ref.getBoundingClientRect().bottom - y0; /* 0 if the browser already anchored */
        if (moved) window.scrollBy(0, moved);
      }
    }, 300);
  }

  function open(host) {
    if (host.__hoOpen) return;
    host.__hoOpen = true;
    var tpl = host.querySelector(':scope > template');
    if (!tpl) return;
    host.appendChild(document.importNode(tpl.content, true)); /* inline data scripts run here */
    tpl.remove();
    host.querySelectorAll('.jdgm-widget[data-entry-point]').forEach(startWidget);
    if (typeof window.HoJdgmLoad === 'function') window.HoJdgmLoad();
    host.classList.add('is-open');
    reveal(host);
    release(host);
  }

  /* The blocks stay invisible (space kept) until Judge.me has drawn them, then appear in
     one go: no half-drawn widget jumping around in front of the shopper. */
  var READY = { review: '.jm-review-widget-header, .jdgm-rev-widg__header, .jdgm-legacy-widget-content .jdgm-rev-widg', grid: '.jdgm-reviews-grid-widget [class*="card"]' };
  function reveal(host) {
    var sel = READY[host.getAttribute('data-ho-lazy-app')] || '*';
    var start = Date.now(), last = -1, stable = 0;
    (function tick() {
      var ok = !!host.querySelector(sel);
      if (ok) { var h = host.scrollHeight; stable = (h === last) ? stable + 1 : 0; last = h; }
      if ((ok && stable >= 2) || Date.now() - start > 10000) { host.classList.add('is-ready'); return; }
      setTimeout(tick, 120);
    })();
  }

  function scrollToReviews() {
    var target = document.querySelector('[data-ho-lazy-app="review"]') || document.querySelector('[data-ho-lazy-app]');
    if (!target) return;
    var header = document.querySelector('.site-header, [data-header-height]');
    var off = header ? Math.min(header.getBoundingClientRect().height, 140) : 0;
    var y = target.getBoundingClientRect().top + window.pageYOffset - off - 12;
    window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' });
  }
  function openAll() { hosts().forEach(open); }

  function setup() {
    var list = hosts();
    if (!list.length) return;
    var mem = remembered();
    list.forEach(function (h) {
      var v = mem[h.getAttribute('data-ho-lazy-app') + '@' + bucket()];
      if (v > 0) h.style.minHeight = v + 'px';
    });
    /* Draw them anyway once the page has finished loading and the phone is idle, so they
       are normally ready before the shopper gets there. */
    var idleOpen = function () {
      var go = function () { openAll(); };
      if ('requestIdleCallback' in window) requestIdleCallback(go, { timeout: 3000 }); else go();
    };
    if (document.readyState === 'complete') setTimeout(idleOpen, 2500);
    else window.addEventListener('load', function () { setTimeout(idleOpen, 2500); });
    /* Arriving with #judgeme_product_reviews (e.g. from an email) shows them at once. */
    if (/judgeme/.test(location.hash)) { openAll(); return; }
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        if (entries.some(function (en) { return en.isIntersecting; })) { io.disconnect(); openAll(); }
      }, { rootMargin: '100% 0px 100% 0px' }); /* one screen ahead, either direction */
      list.forEach(function (h) { io.observe(h); });
    } else {
      openAll();
    }
    /* Star rating under the title / any "see reviews" link: open before the page scrolls. */
    document.addEventListener('click', function (e) {
      var t = e.target;
      if (!(t && t.closest && t.closest('.jdgm-prev-badge, .jdgm-preview-badge, [data-ho-review-jump], a[href*="#judgeme"]'))) return;
      var wasClosed = hosts().some(function (h) { return !h.__hoOpen; });
      openAll();
      /* Judge.me's own "jump to reviews" is not wired up yet when the reviews were still
         deferred, so do the jump here (space is already reserved, the spot will not move). */
      if (wasClosed) { e.preventDefault(); scrollToReviews(); return; }
      /* Already open: Judge.me jumps there itself; if it did not (still busy), we do. */
      setTimeout(function () {
        var r = document.querySelector('[data-ho-lazy-app="review"]');
        if (r && Math.abs(r.getBoundingClientRect().top) > 240) scrollToReviews();
      }, 600);
    }, true);
  }
  /* After DOMContentLoaded, i.e. after Judge.me's own loader has run for the page. */
  if (document.readyState === 'complete') setup();
  else document.addEventListener('DOMContentLoaded', function () { setTimeout(setup, 0); });
})();
